export default {
    container: {
        display: "flex",
        flexDirection: "row",
        columnGap: "20px",
        minWidth: "600px",
        maxWidth: "700px",
        height: "80px",
        padding: "0px 20px",
        backgroundColor:"#E5EEFA"
    },
    topLeftIcon: {
        position: "absolute",
        top: "-8px",
        left: "-8px",
        zIndex: "1"
    },
    cardTitleContainer: {
        flex: "2"
    },
    cardButtonContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    heading: {
        marginBottom: "0"
    },
    paragraph: {
        fontSize: "13px"
    },
    cardButton: {
        fontSize: "14px"
    },
}